import {Mixins, Component} from 'vue-property-decorator';
import DataMixin from '@/components/claim/mixins/ExchangeProductDataMixin';
import {CategroyType} from '@/types/product';
import { addProductDetailUrlPreview } from '@/utils/formatUtils';
// import {i18nInObjectList} from '@/utils/i18n';

@Component
export default class ExchangeProductMethodsMixin extends Mixins(DataMixin) {
  public keywordInfoChange(): void {
    const keywordInfoType = this.searchParams['keywordInfo.type'];
    if (keywordInfoType === 'PRODUCT_MANAGEMENT_CD_LIKE') {
      this.keywordTexthide = false;
    } else {
      this.keywordTexthide = true;
    }
  }

  public cateCascadeTypeChange(categoryObj: any): void {
    Object.assign(this.searchParams, categoryObj);
  }

  // public pageSizeChange(): void {
  //   this.$nextTick((): void => {
  //     this.search();
  //   });
  // }
  public checkKeyword(): boolean {
    let value = this.searchParams['keywordInfo.keywords'] == undefined ? '' : this.searchParams['keywordInfo.keywords'];
    value = value.replace(/(?:\\[rn]|[\r\n]+)+/g, ',');
    let regex = /^[0-9,]+$/;
    if (value != '' && this.searchParams['keywordInfo.type'] == 'MALL_PRODUCT_NO') {
      if (!regex.test(value)) {
        this.keywordCheck = true;
        return false;
      }
    }
    if (value.substring(value.length - 1, value.length) == ',') {
      value = value.substring(0, value.length - 1);
    }
    this.searchParams['keywordInfo.keywords'] = value;
    this.keywordCheck = false;
    return true;
  }

  public search(page: number = 1, size?: number): void {
    if (size) {
      this.searchParams.size = size;
    }
    this.keyTextArea = this.searchParams['keywordInfo.keywords'];
    if (!this.checkKeyword()) {
      return;
    }

    const data: {[propName: string]: any} = {};
    Object.keys(this.searchParams).forEach((prop: any): void => {
      if (this.searchParams[prop] !== -100 && this.searchParams[prop] !== '') {
        Object.assign(data, {[prop]: this.searchParams[prop]});
      }
    });
    let mallNos: string[]  = [data.mallNos]
    delete data.mallNos;
    Object.assign(data, {mallNos});
    Object.assign(data, {page});

    let saleStatus={
      isAll: false,
      types: ['ON_SALE','ON_PRE_SALE']
    }

    let saleSettingStatus={
      isAll: false,
      types: ['AVAILABLE_FOR_SALE']
    }

    let categoryCondition={
      type: data['categoryCondition.type'],
      depth: data['categoryCondition.depth']?data['categoryCondition.depth']:undefined,
      no: data['categoryCondition.no']?data['categoryCondition.no']:undefined,
    }

    let commission={
      range: {
        max: this.searchParams['commission.range.max'],
        min: this.searchParams['commission.range.min'],
      },
      type: this.searchParams['commission.type']
    }

    // let keywordInfo = {
    //   type: data['keywordInfo.type'],
    //   keywords: data['keywordInfo.keywords'],
    // }

    let periodInfo= {
      period: {
        endYmdt: data['periodInfo.period.endYmdt'],
        startYmdt: data['periodInfo.period.startYmdt'],
      },
      type: data['periodInfo.type'],
    }

    let stockRange={
      stockCnt: data['stockRange.stockCnt'],
    }
    Object.assign(data, {saleStatus});
    Object.assign(data, {saleSettingStatus});
    Object.assign(data, {categoryCondition});
    Object.assign(data, {commission});
    if (this.searchParams['keywordInfo.keywords'] && !this.searchParams['keywordInfo.keywords'].trim()) {
      let keywordInfo = {
        type: null,
        keywords: null,
      }
      Object.assign(data, {keywordInfo});
    }else{
      let keywordInfo = {
        type: data['keywordInfo.type'],
        keywords: data['keywordInfo.keywords']?data['keywordInfo.keywords'].split(','):undefined,
      }
      Object.assign(data, {keywordInfo});
    }
    Object.assign(data, {periodInfo});
    Object.assign(data, {stockRange});
    delete data['categoryCondition.type'];
    delete data['categoryCondition.depth'];
    delete data['categoryCondition.no'];
    delete data['commission.range.max'];
    delete data['commission.range.min'];
    delete data['commission.type'];
    delete data['keywordInfo.type'];
    delete data['keywordInfo.keywords'];
    delete data['periodInfo.period.endYmdt'];
    delete data['periodInfo.period.startYmdt'];
    delete data['periodInfo.type'];
    delete data['stockRange.stockCnt'];

    // params.saleStatus.isAll = false
    // params.saleStatus.types = 'ON_SALE,ON_PRE_SALE'
    // params.saleSettingStatus.isAll = false
    // params.saleSettingStatus.types = 'AVAILABLE_FOR_SALE'
   
    this.$api.postProductsSearch({data} as any).then(({data}): void => {
      this.searchRespones = Object.assign({}, data);
      this.gridProps.options.pageOptions.perPage = this.searchParams.size || 0;
      this.gridProps.options.pageOptions.page = page;
      this.gridProps.options.pageOptions.totalCount = data.totalCount;
    });
    this.searchParams['keywordInfo.keywords'] = this.keyTextArea;
  }

  public reset(): void {
    this.searchParams = JSON.parse(JSON.stringify(this.searchParamsBack));
    this.keywordTexthide = true;
    this.categoiesCascade.initDepthData();
    this.getMallCategories();
    this.searchParams['hasAdditionalDiscount'] = 'ALL';
    this.keywordCheck = false;
  }

  public async created(): Promise<any> {
    Object.assign(this.routeQuery, this.$route.query);
    Object.assign(this.searchParams, {mallNos: this.routeQuery.mallNo});
    Object.assign(this.searchParams, {partnerNo: this.routeQuery.partnerNo});
    this.mallNo = this.routeQuery.mallNo;
    Object.assign(this.searchParamsBack, {mallNos: this.routeQuery.mallNo});
    Object.assign(this.searchParamsBack, {partnerNo: this.routeQuery.partnerNo});

    const params = {
      mallNo: this.routeQuery.mallNo
    };
    await this.$api.getMallsContractedPartnersByMallNo({pathParams: params}).then(({data}): void => {
      this.partnerList = data;
    });

    const {data: {productDetailUrl}} = await this.$api.getProductsConfiguration({params: {mallNo: Number(this.routeQuery.mallNo)}})
    this.productDetailUrl = addProductDetailUrlPreview(productDetailUrl);
    

    this.init();
    this.search();
  }

  public mounted(): void {
    this.categoiesCascade = this.$refs.categoiesCascade as any;
  }

  public init(): void {
    this.getMallCategories();
  }

  public getMallCategories(): void {
    const mallNo = Number(this.routeQuery['mallNo']);
    this.$api
      .getDisplayCategoriesTree({
        params: {
          mallNo
        }
      })
      .then(({data}: any): void => {
        this.categoiesCascade.setDepthData(1, this.categoriesDataHandle(data));
      });
  }

  public categoriesDataHandle(array: []): CategroyType[] {
    if (array.length) {
      return array.map(
        (item: any): CategroyType => {
          const value = item.displayCategoryNo || item.categoryNo;
          const label = item.displayCategoryName || item.name;
          const children = this.categoriesDataHandle(item.children || item.child);
          return {value, label, children};
        }
      );
    } else {
      return [];
    }
  }

  public save(): void {
    const gridArea = this.$refs.itemTable as any;
    const gridCheckedRows = gridArea.gridFunction('getCheckedRows');
    const checkedItemsArray = gridCheckedRows ? gridCheckedRows : [];

    if (!checkedItemsArray.length) {
      alert(this.routeQuery.emptyAlert ? decodeURIComponent(this.routeQuery.emptyAlert) : this.$t('CLAIM_EXCHANGEPRODUCT_ALERT_MESSAGE'));
      return;
    }
    $(window.opener.location).attr('href', `javascript:window.${this.routeQuery.callBackName}(${JSON.stringify(checkedItemsArray)});`);
    window.close();
  }

  public close(): void {
    window.close();
  }
}
